module.exports = __webpack_public_path__ + "static/img/earth.7ab7166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/earth.png
// module id = bDLS
// module chunks = 171